import create from './createAction'

export const GET_BT_PAYMENT_METHODS = 'GET_BT_PAYMENT_METHODS'
export const SET_BT_PAYMENT_METHODS = 'SET_BT_PAYMENT_METHODS'
export const DELETE_BT_PAYMENT_METHODS = 'DELETE_BT_PAYMENT_METHODS'

export const getBTPaymentMethods = create(GET_BT_PAYMENT_METHODS)
export const setBTPaymentMethods = create(SET_BT_PAYMENT_METHODS)
export const deleteBTPaymentMethod = create(DELETE_BT_PAYMENT_METHODS)
